import './index.scss'

import React, { useState } from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'
import Icon from 'components/Icon'

const bem = new BEMHelper('label')

export default function Label({
  label,
  error,
  spacing,
  required,
  disabled,
  tooltip,
  children,
  small,
  readOnly,
  className,
  reference,
}) {
  const [showTooltip, setShowTooltip] = useState(false)

  const toggleTooltip = (value) => () => {
    setShowTooltip(value)
  }

  return (
    <label
      {...bem(
        '',
        {
          error,
          disabled,
          'read-only': readOnly,
          tooltip: showTooltip,
          small,
          spacing,
        },
        className,
      )}
      ref={reference}
    >
      {label && (
        <span {...bem('label')}>
          {label}
          {required && (
            <span {...bem('asterix')} aria-label="(påkrevd)">
              ●
            </span>
          )}
        </span>
      )}
      {children}
      {tooltip && (
        <button
          type="button"
          {...bem('tooltip-trigger', { expanded: showTooltip })}
          tabIndex={-1}
          aria-label="Hjelpetekst"
          aria-expanded={showTooltip}
          onClick={toggleTooltip(!showTooltip)}
          onBlur={toggleTooltip(false)}
        >
          <Icon icon="info" {...bem('info-icon')} />
        </button>
      )}
      {showTooltip && (
        <span {...bem('tooltip')} role="alert">
          {tooltip}
        </span>
      )}
      {error && (
        <span {...bem('error')} role="alert">
          {error}
        </span>
      )}
    </label>
  )
}

Label.propTypes = {
  label: T.string,
  error: T.string,
  tooltip: T.string,
  spacing: T.bool,
  required: T.bool,
  disabled: T.bool,
  readOnly: T.bool,
  small: T.bool,
  className: T.string,
  reference: T.oneOfType([T.func, T.object]),
  children: T.any,
}
